package com.iregained.eventapp.components.sections.event_booking.sections

import androidx.compose.runtime.*
import com.iregained.eventapp.components.models.PatientIntakeFormState
import com.iregained.eventapp.components.sections.event_booking.styles.CardContainerStyle
import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Checkbox
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px

@Composable
fun EventIntakeFormSection(
    formState: PatientIntakeFormState, isSubmitting: Boolean, // Added to handle loading state
    onSubmit: () -> Unit
) {
    val palette = ColorMode.current.toSitePalette()
    var errorMessage by remember { mutableStateOf("") }

    // 1. FIX REATIVITY: Create local state for all inputs so the UI updates as the user types
    var fullName by remember { mutableStateOf(formState.fullName) }
    var email by remember { mutableStateOf(formState.email) }
    var phone by remember { mutableStateOf(formState.phone) }
    var conditionNotes by remember { mutableStateOf(formState.conditionNotes) }
    var consentTransactional by remember { mutableStateOf(formState.consentTransactional) }
    var consentSms by remember { mutableStateOf(formState.consentSms) }
    var consentMarketing by remember { mutableStateOf(formState.consentMarketing) }

    // 2. ANTI-BOT: Dynamic Math Challenge
    val botNum1 = remember { (1..10).random() }
    val botNum2 = remember { (1..10).random() }
    val expectedAnswer = (botNum1 + botNum2).toString()
    var mathAnswer by remember { mutableStateOf("") }

    Column(
        modifier = CardContainerStyle.toModifier().backgroundColor(palette.custom.cardBackground)
            .margin(topBottom = 24.px), horizontalAlignment = Alignment.Start
    ) {
        SpanText(
            text = "2. Patient Intake & Contact Information",
            modifier = Modifier.fontSize(20.px).fontWeight(FontWeight.Bold).margin(bottom = 16.px)
        )

        // Name
        SpanText("Full Name *", modifier = Modifier.fontSize(14.px).margin(bottom = 4.px))
        Input(
            type = InputType.Text,
            value = fullName,
            onValueChange = { fullName = it },
            modifier = Modifier.fillMaxWidth().margin(bottom = 12.px)
        )

        // Email
        SpanText("Email Address *", modifier = Modifier.fontSize(14.px).margin(bottom = 4.px))
        Input(
            type = InputType.Email,
            value = email,
            onValueChange = { email = it },
            modifier = Modifier.fillMaxWidth().margin(bottom = 12.px)
        )

        // Phone
        SpanText("Phone Number *", modifier = Modifier.fontSize(14.px).margin(bottom = 4.px))
        Input(
            type = InputType.Tel,
            value = phone,
            onValueChange = { phone = it },
            modifier = Modifier.fillMaxWidth().margin(bottom = 12.px)
        )

        // Condition Notes
        SpanText("Hand Rehab Condition Notes", modifier = Modifier.fontSize(14.px).margin(bottom = 4.px))
        Input(
            type = InputType.Text,
            value = conditionNotes,
            onValueChange = { conditionNotes = it },
            modifier = Modifier.fillMaxWidth().margin(bottom = 16.px)
        )

        // Anti-Bot Verification
        SpanText(
            "Security Verification: What is $botNum1 + $botNum2? *",
            modifier = Modifier.fontSize(14.px).margin(bottom = 4.px)
        )
        Input(
            type = InputType.Text,
            value = mathAnswer,
            onValueChange = { mathAnswer = it },
            modifier = Modifier.fillMaxWidth().margin(bottom = 16.px)
        )

        // Consents
        SpanText("Communication Preferences", modifier = Modifier.fontWeight(FontWeight.Bold).margin(bottom = 8.px))

        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.margin(bottom = 8.px)) {
            Checkbox(
                checked = consentTransactional, onCheckedChange = { consentTransactional = it })
            SpanText(" Receive transactional emails & calendar invitations", modifier = Modifier.fontSize(14.px))
        }

        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.margin(bottom = 8.px)) {
            Checkbox(
                checked = consentSms, onCheckedChange = { consentSms = it })
            SpanText(" Receive SMS event reminders", modifier = Modifier.fontSize(14.px))
        }

        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.margin(bottom = 16.px)) {
            Checkbox(
                checked = consentMarketing, onCheckedChange = { consentMarketing = it })
            SpanText(" Receive MyHand® product updates and clinical news", modifier = Modifier.fontSize(14.px))
        }

        // Validation Error Display
        if (errorMessage.isNotEmpty()) {
            SpanText(
                text = errorMessage, modifier = Modifier.color(Colors.Red).fontSize(14.px).margin(bottom = 12.px)
            )
        }

        Button(
            onClick = {
                // Validation Logic
                if (fullName.isBlank() || email.isBlank() || phone.isBlank() || mathAnswer.isBlank()) {
                    errorMessage = "Please fill in all required fields (*)."
                } else if (mathAnswer.trim() != expectedAnswer) {
                    errorMessage = "Incorrect security verification. Please try the math problem again."
                } else {
                    errorMessage = ""

                    // Sync local Compose state back to the parent data object before submitting
                    formState.fullName = fullName
                    formState.email = email
                    formState.phone = phone
                    formState.conditionNotes = conditionNotes
                    formState.consentTransactional = consentTransactional
                    formState.consentSms = consentSms
                    formState.consentMarketing = consentMarketing

                    onSubmit()
                }
            }, enabled = !isSubmitting, // Disable button while processing
            modifier = Modifier.fillMaxWidth().padding(topBottom = 12.px)
        ) {
            SpanText(if (isSubmitting) "Processing Booking..." else "Confirm Booking Request")
        }
    }
}